import React from "react"
import ContentTeam from "./ContentTeam"
import DesignTeam from "./DesignTeam"
import EventTeam from "./EventTeam"
import MediaTeam from "./MediaTeam"
import TechnicalTeam from "./TechnicalTeam"
import ProjectsTeam from "./ProjectsTeam"
import styles from "./Team.module.css"
// import TopSection from './TopSection';

const Team = () => {
  return (
    <div className={styles.mainContainer}>
      {/* <TopSection/> */}
      <ContentTeam />
      <ProjectsTeam />
      <DesignTeam />
      <EventTeam />
      <MediaTeam />
      <TechnicalTeam />
    </div>
  )
}

export default Team
